import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CrudCampaignComponent } from './crud-campaign/crud-campaign.component';
import { ManageCampaignComponent } from './manage-campaign/manage-campaign.component';

const routes: Routes = [
  {
    path: 'add',
    component: CrudCampaignComponent,
  },
  {
    path: 'view/:id',
    component: CrudCampaignComponent,
  },
  {
    path: '',
    component: ManageCampaignComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CampaignRoutingModule {}
